/**
 * Build-time gate for the **visual-only** Flow-taste surface.
 *
 * This flag exists so the Flow-taste *presentation* (gallery card craft,
 * shimmer in-flight cards, graceful failed cards, prompt-shell scrim markers)
 * can be promoted to PRODUCTION independently of the FUNCTIONAL preview-only
 * features (agent mode, video, model picker, FlowRail live data + spaces nav,
 * gallery view/size controls) which stay behind `isPreviewModelPickerEnabled()`.
 *
 * It is intentionally a PURE build constant resolved from
 * `NEXT_PUBLIC_ENABLE_FLOW_TASTE`:
 *   - NO hostname inspection
 *   - NO `NEXT_PUBLIC_STAGE`
 *   - NO runtime / `window` fallback
 *
 * The build constant is identical on the server (SSR) and the client (CSR),
 * so it can never produce a hydration mismatch the way a hostname/stage-derived
 * gate could. Any value other than the literal string `"true"` (unset, empty,
 * `"false"`, anything else) keeps the Flow-taste surface OFF.
 *
 * IMPORTANT: never import this in `apps/server` — it is a web-build-only flag
 * and must not influence any model / agent / video routing decision.
 */
export const isFlowTasteEnabled = (): boolean =>
  process.env.NEXT_PUBLIC_ENABLE_FLOW_TASTE === "true";
